<div class="video-player-container">
  <div class="video-wrap">
    <img *ngIf="!hidePoster" class="video-poster" [src]="videoPoster" />
    <video
      [hidden]="!hidePoster"
      #video
      controls
      [src]="videoUrl"
      class="video-player"
    ></video>
    <div class="player-controls player-controls-large" *ngIf="!hidePoster">
      <span class="play-button" (click)="onPlayVideo()">
        <div class="play"></div>
      </span>
    </div>
  </div>
  <div
    class="player-controls player-controls-small"
    *ngIf="!hidePoster"
    (click)="onPlayVideo()"
  >
    <span class="play-button">
      <div class="play"></div>
    </span>
    <span class="play-video">Play video</span>
  </div>
</div>
